import React from 'react';

import { Container } from './Splash.styles';

const Splash = (props: { children: React.ReactNode }) => {
  return <Container>{props.children}</Container>;
};

export default Splash;
